import { useEffect, useState } from 'react';

export type BoardRootId = 'timetable-grid' | 'teaching-block-grid';

/**
 * Ziel-Element für das Portal der Kontextmenüs auf einer Stecktafel: der Board-Wrapper
 * (`#timetable-grid` bzw. `#teaching-block-grid`).
 *
 * Warum nicht ohne Portal: Das Grid hat `transform`/`will-change: transform` und ist damit der
 * Containing Block für das `position: fixed` des Menüs. Das Menü sitzt dann in den
 * `overflow: hidden`-Containern des Boards; öffnet es am unteren Rand, ragt es über sie hinaus,
 * und sobald Radix den Fokus ohne `preventScroll` auf das Menü setzt (Maus verlässt einen
 * Eintrag), scrollt der Browser diese Container – das Board verrutscht.
 *
 * Warum nicht `document.body`: Im Vollbild ist der Board-Wrapper das Fullscreen-Element; alles
 * außerhalb davon ist unsichtbar. Der Wrapper liegt außerhalb des transformierten Grids und
 * funktioniert daher in beiden Modi.
 *
 * Beim ersten Mount des Boards existiert der Wrapper während des Renders der Kinder noch nicht
 * im DOM; dann wird er nach dem Commit nachgeschlagen (ein zusätzlicher Render).
 */
export function useBoardMenuContainer(rootId: BoardRootId): HTMLElement | null {
  const [container, setContainer] = useState<HTMLElement | null>(() => document.getElementById(rootId));

  useEffect(() => {
    if (!container?.isConnected) {
      setContainer(document.getElementById(rootId));
    }
  }, [container, rootId]);

  return container;
}
